import React, { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Grid3X3 } from 'lucide-react';
import { RoleMarginMatrix } from './RoleMarginMatrix';

/** Small trigger + full-width dialog wrapping the role × group matrix (used from the estimator's Live Estimate card). */
export function RoleMarginDialogButton({ estimateId, onApplied, className = '' }) {
  const [open, setOpen] = useState(false);
  if (!estimateId) return null;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)}
        className={`inline-flex items-center gap-1 text-[10px] font-semibold text-white/80 hover:text-white underline-offset-2 hover:underline ${className}`}
        data-testid="estimator-role-margin-btn" title="Margin by role × component group, with rate what-if">
        <Grid3X3 className="w-3 h-3" /> Role margin &amp; what-if
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-[1100px] max-h-[90vh] overflow-y-auto" data-testid="role-margin-dialog">
          <DialogHeader>
            <DialogTitle className="text-[#0F2040]">Role margin &amp; rate what-if</DialogTitle>
            <DialogDescription>
              Sell vs internal cost for every role across this estimate's component groups. Change a sell or cost rate to see the impact per group and overall; apply sell rates to save them as this estimate's rate card override (same hours, new version).
            </DialogDescription>
          </DialogHeader>
          <RoleMarginMatrix estimateId={estimateId} onApplied={(d) => { setOpen(false); onApplied?.(d); }} />
        </DialogContent>
      </Dialog>
    </>
  );
}
